import styled from 'styled-components';

export const PageContainer = styled.div`
  height: 100%;
  display: flex;
  flex-direction: row;
  background-color: ${(props) =>
    props.theme.atlas.semantic.color.surface.variant};
  padding: 24px;
  display: flex;
  flex-direction: column;
`;

export const TableHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const TableActions = styled.div`
  display: flex;
  column-gap: 32px;
  .select__menu {
    top: 100%;
    background-color: #ffffff;
    border-radius: 5px;
    box-shadow:
      0 0 0 1px hsla(0, 0%, 0%, 0.1),
      0 4px 11px hsla(0, 0%, 0%, 0.1);
    margin-bottom: 8px;
    margin-top: 8px;
    position: absolute;
    z-index: 1;
    box-sizing: border-box;
    min-width: 180px;
    font-size: 14px;
    font-weight: 400;
    font-family: ${(props) =>
      props.theme.atlas.typography.semantic.body.fontFamily};
    border: 1px solid
      ${(props) => props.theme.atlas.semantic.color.ui.divider.default};
    text-align: left;
    align-items: center;
  }
`;

export const ButtonsRow = styled.div`
  display: flex;
  justify-content: flex-end;
  flex-wrap: wrap-reverse;
  width: 100%;
  column-gap: 10px;

  > button {
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 2px;
    padding: 7px 10px;
    line-height: 16px;

    i {
      padding-right: 6px;
    }
  }
`;

export const TableContainer = styled.div`
  margin-top: 20px;
  border-radius: 12px;
  box-shadow:
    0px 0px 1px 0px rgba(0, 0, 0, 0.4),
    0px 8px 24px -6px rgba(0, 0, 0, 0.16);
  background-color: ${(props) =>
    props.theme.atlas.semantic.color.surface.default};
  min-width: 980px;
  position: relative;
`;

export const PermissionsContainer = styled.div`
  display: flex;
  gap: 5px;
`;

export const EmptyStateContainer = styled.div`
  display: flex;
  align-items: center;
  padding-top: 71px;
`;
